// src/api.js
import axios from "axios";

const host = process.env.REACT_APP_BACKEND_HOST || "localhost";
const port = process.env.REACT_APP_BACKEND_PORT || "8000";
const protocol = process.env.BACKEND_PROTOCOL || "http";

const api = axios.create({
  baseURL: `https://${host}:${port}/api`, // aws
  // baseURL: `${protocol}://${host}:${port}/api`, // bml
  headers: {
    "Content-Type": "application/json",
  },
});

export default api;
